export const SET_LOADING = '@provider/basis-theory/set-loaded';

export const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading,
  };
};
